"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@alcumus/components");
const look_1 = require("../../../server/models/look");
const dashboard_1 = require("../../../server/models/dashboard");
const ReportBasePage_1 = __importDefault(require("../BasePage/ReportBasePage"));
const RecentRoute_1 = __importDefault(require("../../../routes/RecentRoute"));
const EmptyState_1 = __importDefault(require("../EmptyState/EmptyState"));
const RecentReportsPage = ({ t, tReady }) => {
    const headers = [
        { id: 'icon', displayName: '' },
        { id: 'name', displayName: t('name', { ns: 'TableHeaders' }) },
        { id: 'lastViewed', displayName: t('lastViewed', { ns: 'TableHeaders' }) },
        { id: 'createdBy', displayName: t('owner', { ns: 'TableHeaders' }) },
        { id: 'folder', displayName: t('folder', { ns: 'TableHeaders' }) },
        {
            id: 'contentFavoriteId',
            displayName: t('favorite', { ns: 'TableHeaders' }),
        },
    ];
    const emptyState = (react_1.default.createElement(EmptyState_1.default, { dashboardText: t('recentDashboardText'), lookText: t('recentLookText') }));
    return (react_1.default.createElement(components_1.TranslateReady, { tReady: tReady },
        react_1.default.createElement(ReportBasePage_1.default, { title: RecentRoute_1.default.friendlyName, getDashboardsFunction: () => (0, dashboard_1.searchRecentlyViewedDashboard)(), getLooksFunction: () => (0, look_1.searchRecentlyViewedLook)(), headers: headers, showLastViewed: true, emptyState: emptyState })));
};
exports.default = (0, react_i18next_1.withTranslation)(['EmptyState', 'TableHeaders'])(RecentReportsPage);
